module.exports = __webpack_public_path__ + "static/img/icon-tip-yellow.73f4fb26.svg";